import cn from 'classnames'
import { motion } from 'framer-motion'
import { createPortal } from 'react-dom'

import styles from './Backdrop.module.scss'

export function Backdrop({
  onClick,
  children,
  className,
}: {
  onClick?(): void
  children: any
  className?: string
}) {
  return createPortal(
    <motion.div
      className={cn(styles.backdrop, className)}
      onClick={onClick ? onClick : undefined}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {children}
    </motion.div>,
    document.querySelector('#root') as HTMLElement
  )
}
